import { render, staticRenderFns } from "./EditGeneralDialog.vue?vue&type=template&id=4da83d1c&"
import script from "./EditGeneralDialog.vue?vue&type=script&lang=ts&"
export * from "./EditGeneralDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports